<template>
  <div>
    <maintenance />
    <div v-if="!hideWorkspace">
      <mode-of-contact />
      <your-details v-if="token && token.length > 0" />
      <your-products v-if="step >= 2" />
      <your-request v-if="step >= 3" />
    </div>
  </div>
</template>

<script>
import ModeOfContact from "../components/ModeOfContact";
import YourDetails from "./YourDetails";
import YourProducts from "./YourProducts";
import YourRequest from "./YourRequest";
import Maintenance from "./Maintenance";
import Auth from "../mixins/auth";
import { mapState, mapMutations, mapActions } from "vuex";
import * as types from "../store/mutation-types";
import { i18n } from "../config";
import {
  languageCode,
  getStoreCodeByUrl,
  getStoreCountryNameByCode,
  storeList,
} from "../mixins/store";

export default {
  name: "Home",
  components: {
    ModeOfContact,
    YourDetails,
    YourProducts,
    YourRequest,
    Maintenance,
  },
  data: () => ({
    token: "",
    hideWorkspace: false,
  }),
  computed: {
    ...mapState({
      store: "store",
      step: "step",
    }),
  },
  mounted() {
    let zopimScript = document.createElement("script");
    zopimScript.setAttribute("id", "ze-snippet");
    zopimScript.setAttribute(
      "src",
      "https://static.zdassets.com/ekr/snippet.js?key=ba51a759-7f5b-46c0-8b9d-cb2f8aeca9cf"
    );
    zopimScript.async = true;
    //document.head.appendChild(zopimScript)

    // let departments;
    // let chat_en = `If you are contacting us about the status of your RMA, the process will take approximately 3-5 business days from date of receiving your product by Creative.
    //               \r
    //               To check the status of your RMA, please visit our contact us page: https://creative.com/contactus/.
    //               \r
    //               Select "Check Replacement/Return status" under "Your Enquiry" and fill out the form.`
    // let chat_de = `Wenn Sie uns wegen des Status Ihrer RMA kontaktieren, dauert der Vorgang ab dem Datum des Erhalts Ihres Produkts bei Creative ungefähr 3-5 Werktage.
    //               \r
    //                Um den Status Ihrer RMA zu überprüfen, nutzen Sie bitte unser Kontaktformular: https://creative.com/contactus/.
    //               \r
    //               Wählen Sie unter "Ihre Anfrage" "Überprüfen Sie den Ersatz- / Rückgabestatus" und füllen Sie das Formular aus.`;
    // let enquiry_en = "Type of Enquiry"
    // let enquiry_de = "Art der Anfrage"

    // switch (this.store) {
    //   case "de":
    //     departments = ["kopfhörer", "andere", "lautsprecher", "soundkarten"];
    //     break;
    //   default:
    //     departments = ["speakers", "amplifiers", "headphones", "sound cards", "others" ];
    //     break;
    // }

    // if (typeof (window.zE) == 'function') {
    //   window.zE('webWidget:on', 'chat:status', function (status) {
    //     window.console.log('Chat Status (Home.vue): ' + status)
    //     //$(".livechat-status").html(": " + status);

    //   });
    // }
    // else {
    //   window.console.log("(Home: Line 90) : Error loading chat widget")
    // }

    switch (this.store) {
      case "sg":
      case "au":
      case "us":
      case "ca":
      case "uk":
        if (typeof (window.zE) == 'function') {
          // window.zE("messenger", "setLocale", 'en');
          // //window.zE.show();
          try {
            window.zE('messenger', 'show');
          }
          catch(e) {
            window.zE('webWidget', 'show');
          }
        }
        break;
      default:
        if (typeof (window.zE) == 'function') {
          // window.zE.hide();
          try {
            window.zE('messenger', 'hide')
          }
          catch(e) {
            window.zE('webWidget', 'hide');
          }
        }
        break;
    }
  },
  methods: {
    ...mapMutations({
      changeStore: types.CHANGE_STORE,
      changeStep: types.CHANGE_STEP,
      showPageLoading: types.SHOW_LOADING,
      hidePageLoading: types.HIDE_LOADING,
    }),
    ...mapActions({
      updatePageTitle: types.SET_PAGE_TITLE,
      updatePageDesc: types.SET_PAGE_DESC,
      updatePageLang: types.SET_PAGE_LANG,
    }),
  },
  async created() {
    // If timing hit, disable RMA page and show only the msg
    let dtNow = new Date();
    let dtStart = new Date("2022-10-09 8:30:00 AM");
    let dtEnd = new Date("2022-10-09 3:00:00 PM");

    // Home.vue
    if (dtNow >= dtStart && dtNow <= dtEnd) {
      this.hideWorkspace = true;
    }

    // guest authorization
    this.showPageLoading();
    let token = Auth.getToken();
    if (!token || token.length == 0)
      token = await Auth.authenticate(this.store);
    if (token && token.length > 0) Auth.updateToken(token);
    this.token = token;
    const code = getStoreCodeByUrl(location.href);
    const countryName = getStoreCountryNameByCode(this.store);
    if (code && storeList.indexOf(code) >= 0) this.changeStore(code);
    i18n.locale = languageCode[this.store] ? languageCode[this.store] : "en";
    this.$scrollTo("#app");
    this.hidePageLoading();

    if (i18n.locale == "en") {
      this.updatePageTitle(`${this.$t("page-title")} (${countryName})`);
    } else {
      this.updatePageTitle(`${this.$t("page-title")}`);
    }
    this.updatePageDesc(this.$t("page-desc"));

    switch (true) {
      case window.location.href.includes("enquiry/return"):
        if (!this.$t("page-title-return").includes("page-title-return")) {
          this.updatePageTitle(this.$t("page-title-return"));
          this.updatePageDesc(this.$t("page-desc-return"));
        }
        break;

      case window.location.href.includes("enquiry/replacement"):
        if (
          !this.$t("page-title-replacement").includes("page-title-replacement")
        ) {
          this.updatePageTitle(this.$t("page-title-replacement"));
          this.updatePageDesc(this.$t("page-desc-replacement"));
        }
        break;

      case window.location.href.includes("enquiry/rma-status"):
        if (
          !this.$t("page-title-checkstatus").includes("page-title-checkstatus")
        ) {
          this.updatePageTitle(this.$t("page-title-checkstatus"));
          this.updatePageDesc(this.$t("page-desc-checkstatus"));
        }
        break;
    }

    this.updatePageLang(i18n.locale);
  },
};
</script>
